import React, { Component } from 'react'
import { TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7 } from '../../../../../../config/tables'
import MuiTable from '../../../../../Forms/SharedComponents/containers/MuiTable'
import { Container, Row, Col } from 'react-bootstrap'

export class ReporteEmbarqueSector3Linea7View extends Component {
  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={12}>
            <h2>Sector 3 Linea 7</h2>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <MuiTable id={TABLA_REPORTE_EMBARQUE_SECTOR_3_LINEA_7} />
          </Col>
        </Row>
      </Container>
    )
  }
}
